export default function (message, defaultText) {
    if (!message) {
        return defaultText ? defaultText : "no message";
    }
    let lang = this.$store.getters['app/getLang'];
    const context = require.context('./', true, /\.json$/);
    context.keys().map(key => {
        let arr = key.replace('./', '').split('/');
        let find = this.$store.getters['app/getLocalLang'](arr[0]);
        if (!find) {
            this.$store.commit("app/initLocalLang", { name: arr[0], value: context(key) });
        }
    });
    let find = this.$store.getters['app/getLocalLang'](lang);
    if (find) {
        let marr = message.split(".");
        if (marr) {
            let p;
            for (let i = 0; i < marr.length; i++) {
                let a = marr[i];
                if (p == undefined) {
                    if (find[a]) {
                        p = find[a];
                    }
                } else {
                    if (p[a]) {
                        p = p[a];
                    }
                }
            }
            if (p && typeof p == "string") {
                return p;
            }
        }
    }
    return defaultText ? defaultText : "no message";
}